// Story-aware landing hero. Build flag defaults off.
// CRA inlines REACT_APP_* only for a static member read.
// The hero is client-rendered, so there is no server mirror.

export const STORY_HEADLINE_CLIENT_ENV = "REACT_APP_DOPLE_STORY_HEADLINE";

const TRUTHY = new Set(["1", "true", "yes", "on"]);

export function parseStoryHeadlineFlag(value) {
  if (value === true) return true;
  return TRUTHY.has(String(value ?? "").trim().toLowerCase());
}

export function storyHeadlineEnabled() {
  return parseStoryHeadlineFlag(process.env.REACT_APP_DOPLE_STORY_HEADLINE);
}
